// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { deleteRegisteredUser as deleteRegisteredUserApi } from "@stoneage/App/Services/CourseManagement/CourseManagementService";

export interface DeleteRegisteredUserApiParameter {
    registrationId: string;
    courseId: string;
}

type HandlerType = ApiHandler<
    DeleteRegisteredUserApiParameter & HasOnSuccess<ServiceResult<void>> & HasOnError<string>,
    ServiceResult<void>
>;
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DeleteRegisteredUserApi: HandlerType = async props => {
    const { onSuccess, onError, ...apiParameter } = props.apiParameter;
    props.apiResult = await deleteRegisteredUserApi(apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, DeleteRegisteredUserApi, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];
const deleteRegisteredUser = createHandlerChainRunner(chain, "DeleteRegisteredUser");

export default deleteRegisteredUser;
